import { UPDATE_CATEGORIES } from "./constants"

export default {
  [UPDATE_CATEGORIES](state, categories) {
    state.categories = categories
  }
}
